import { contentfulClient } from "App"
import * as types from "store/constants"

const loadingContentful = () => ({ type: types.LOADING_CONTENTFUL })

export const fetchEcommerceProducts = ({ category = "" } = {}) => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "product", "fields.category": category })
		.then(({ items }) => {
			dispatch({ type: types.FETCH_ECOMMERCE_PRODUCTS, payload: items.map((item) => item.fields) })
		})
		.catch((err) => {
			dispatch({ type: types.FETCH_ECOMMERCE_PRODUCTS_ERROR })
			console.error(err)
		})
}

export const fetchEcommerceSites = () => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "eCommerceSites" })
		.then(({ items }) => dispatch({ type: types.FETCH_ECOMMERCE_SITES, payload: items.map((item) => item.fields) }))
		.catch((err) => {
			dispatch({ type: types.FETCH_ECOMMERCE_SITES_ERROR })
			console.error(err)
		})
}

export const fetchShopCategories = () => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "product", select: "fields.category" })
		.then(({ items }) => dispatch({ type: types.FETCH_SHOP_CATEGORIES, payload: items.map((item) => item.fields) }))
		.catch((err) => {
			dispatch({ type: types.FETCH_SHOP_CATEGORIES_ERROR })
			console.error(err)
		})
}

export const fetchConsultants = () => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "consultants" })
		.then(({ items }) => {
			dispatch({ type: types.FETCH_CONSULTANTS, payload: items.map((item) => item.fields) })
		})
		.catch((err) => {
			dispatch({ type: types.FETCH_CONSULTANTS_ERROR })
			console.error(err)
		})
}

export const fetchLifelongSliders = () => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "lifelongSlider" })
		.then(({ items }) => {
			dispatch({ type: types.FETCH_LIFELONG_SLIDERS, payload: items.map((item) => item.fields) })
		})
		.catch((err) => {
			dispatch({ type: types.FETCH_LIFELONG_SLIDERS_ERROR })
			console.error(err)
		})
}

export const fetchAssessments = (category) => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "counsellingAssessment", "fields.category.sys.id": category.id })
		.then(({ items }) => {
			const data = items.map((item) => item.fields)
			dispatch({ type: types.FETCH_ASSESSMENTS, payload: { data, category: category.slug } })
		})
		.catch((err) => {
			dispatch({ type: types.FETCH_ASSESSMENTS_ERROR })
			console.error(err)
		})
}

export const fetchAssessmentOptions = (category) => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "counsellingOptions" })
		.then(({ items }) => {
			dispatch({
				type: types.FETCH_ASSESSMENT_OPTIONS,
				payload: { data: items.map((item) => item.fields), category }
			})
		})
		.catch((err) => {
			dispatch({ type: types.FETCH_ASSESSMENT_OPTIONS_ERROR })
			console.error(err)
		})
}

export const fetchAssessmentCategories = () => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "counsellingCategories" })
		.then(({ items }) => {
			dispatch({
				type: types.FETCH_ASSESSMENT_CATEGORIES,
				payload: items.map((item) => ({ ...item.fields, id: item.sys.id }))
			})
		})
		.catch((err) => {
			dispatch({ type: types.FETCH_ASSESSMENT_CATEGORIES_ERROR })
			console.error(err)
		})
}

export const fetchAssessmentResults = (points) => (dispatch) => {
	dispatch(loadingContentful())
	return contentfulClient
		.getEntries({ content_type: "counsellingResults" })
		.then(({ items }) => {
			dispatch({ type: types.FETCH_ASSESSMENT_RESULTS, payload: items.map((item) => item.fields), points })
		})
		.catch((err) => {
			dispatch({ type: types.FETCH_ASSESSMENT_RESULTS_ERROR })
		})
}
